<template>
  <InputBase
    v-bind="{ ...props, ...input }"
    :class="['input-range', !!slots.icon ? 'input-range--has-icon' : undefined]"
  >
    <span v-if="!!slots.icon" class="input-range__icon-wrap">
      <span class="input-range__icon">
        <slot name="icon" />
      </span>
    </span>
    <input
      v-model.number="modelValue"
      ref="inputEl"
      :id="input.id"
      type="range"
      class="input-range__input"
      v-bind="$attrs"
    />
  </InputBase>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import {
  type InputProps,
  inputPropsDefaults,
  useInput,
} from '@/composables/input'

defineOptions({
  inheritAttrs: false,
})

interface InputRangeProps extends InputProps {}

const props = withDefaults(defineProps<InputRangeProps>(), {
  ...inputPropsDefaults,
})

const slots = defineSlots<{
  icon(): any
}>()

const modelValue = defineModel<number>({
  default: 1,
})

const input = useInput()
const inputEl = useTemplateRef<HTMLInputElement>('inputEl')
</script>

<style lang="scss" scoped>
.input-range {
  --input-margin-left: 0;
  --padding-right: var(--input-spacing);
  --icon-color: inherit;
  --icon-opacity: 0.6;

  width: 100%;
  max-width: 200px;

  &:focus-within {
    --icon-color: var(--color-primary);
    --icon-opacity: 1;
  }

  &--has-icon {
    --input-margin-left: calc(var(--input-spacing) + 0.75em);
  }

  &__input {
    display: block;
    margin: 0 0 0 var(--input-margin-left);
    width: calc(100% - var(--input-margin-left));
    cursor: pointer;
    accent-color: var(--color-primary);
  }

  &__icon-wrap {
    opacity: var(--icon-opacity);
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 0;
    color: var(--icon-color);
    transform: translateY(-50%);
    transition: color 200ms ease;
  }

  &__icon {
    font-size: 1.2em;
  }
}
</style>
